import { render, staticRenderFns } from "./HideParamnsSwitch.vue?vue&type=template&id=32b41530&"
import script from "./HideParamnsSwitch.vue?vue&type=script&lang=js&"
export * from "./HideParamnsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./HideParamnsSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports